import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'aid-session-timeout',
  template: `
    <aid-dialog [title]="'session-timeout'" (close)="onClose()">
      <div class="aid-layout-column aid-layout-gap-32">
        <div class="mat-subtitle-2">
          {{ 'session-timeout-message' | translate | sentancecase }}
        </div>
        <div class="aid-layout-row aid-layout-align-end-center">
          <aid-loading-button [label]="'login'" (press)="onClose()">
          </aid-loading-button>
        </div>
      </div>
    </aid-dialog>
  `,
  styleUrls: ['./session-timeout.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SessionTimeoutComponent implements OnInit {
  constructor(private dialogRef: MatDialogRef<SessionTimeoutComponent>) {}

  ngOnInit() {}

  onClose() {
    this.dialogRef.close();
  }
}
